import * as types from "./mutation-type";

export default {
  [types.SET_MODULES](state, payload) {
    state.modules = payload
  },

}
